import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

// import Logo from "../../Assets/Images/logo_white.svg";
// import steeringWheel from "../../Assets/Images/steering-wheel.webp";
// import playStore from "../../Assets/Images/play-store.svg";
// import appStore from "../../Assets/Images/app-store.svg";
// import screenImg from "../../Assets/Images/screen.webp";

import "../../Assets/CSS/landing.css";
import { useDispatch } from "react-redux";
import { FetchStaticPageByURL } from "../../Admin/Redux/static";
import { Static } from "../../Types/state/staticPages.state";
import { useSelector } from "react-redux";
const Home: React.FC = () => {
	// const navigate = useNavigate();
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);

	const { singleStaticPage } = useSelector((state: Static) => state.static);

	useEffect(() => {
		FetchStaticPageByURL("home", setIsLoading)(dispatch);
	}, []);

	return (
		<>
			{isLoading ? (
				<div className="loader-container py-5 h-100 d-flex justify-content-center align-items-center">
					<div className="loader">
						<div className="spinner-border" style={{ width: "4rem", height: "4rem" }} role="status"></div>
					</div>
				</div>
			) : (
				<div className="h-100" dangerouslySetInnerHTML={{ __html: singleStaticPage?.html as string }}></div>
			)}

			{/* <div
				className="landing-container h-100 position-relative overflow-hidden"
				style={{
					backgroundImage: `url(${steeringWheel})`,
				}}
			>
				<img src={steeringWheel} width={360} height={360} className="position-absolute object-fit-contain steering-top-right" />
				<img src={steeringWheel} width={360} height={360} className="position-absolute object-fit-contain steering-bottom-left" />
				<div className="d-flex justify-content-center align-items-center h-100 position-relative overflow-auto">
					<div className="page-container d-flex flex-column h-100 p-lg-4 p-3">
						<div className="text-center">
							<a href="#">
								<img src={Logo} width={297} height={100} className="img-fluid object-fit-contain landing-logo" alt="Logo" />
							</a>
						</div>
						<div className="flex-fill d-flex align-items-center">
							<div className="row align-items-center justify-content-center">
								<div className="col-xl-6 col-lg-7 col-md-9 text-lg-start text-center">
									<h1 className="text-p-primary fw-bold main-section-h1">TURN YOUR SOLO ADVENTURES INTO SOCIAL EXPERIENCES</h1>
									<p className="fs-5 text-black">
										Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it
										to make a type specimen book.
									</p>
									<div className="d-flex flex-wrap justify-content-lg-start justify-content-center gap-4">
										<a href="#" className="d-inline-block storeButton">
											<img src={playStore} width={300} height={80} className="img-fluid" alt="Google Play Store" />
										</a>
										<a href="#" className="d-inline-block storeButton">
											<img src={appStore} width={300} height={80} className="img-fluid" alt="Google Play Store" />
										</a>
									</div>
								</div>
								<div className="col-xl-6 col-lg-5 col-md-9 text-lg-end">
									<img src={screenImg} width={629} height={775} className="img-fluid object-fit-contain screenImage" alt="Image" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</div> */}
		</>
	);
};

export default Home;
